import React, {useState, useEffect} from 'react'
import {ModulePanel, ModuleHeader, ModuleBody, ModuleFooter} from 'containers/purchase/modules/module_panel'
import { useTranslation } from 'react-i18next'
// import {currentStep} from 'utils/step_utils'
import {get} from 'lodash'
import cn from 'classnames'
// import {initializeWidget} from './onebox_lib'

const ExperticketIframeModule = (props) => {
  const {machine, status} = props
  const [current, send] = machine
  const {iframe_key, iframe_container_id, iframe_url, iframe_height} = current.context
  const { t, i18n } = useTranslation()

  return (
    <ModulePanel>
      <ModuleHeader status={status} onClick={() => status == 'completed' ? send('REOPEN_IFRAMESTEP') : null}>
        <span>
          <i className="fa fa-map-marker me-2" aria-hidden="true"></i>
          {i18n.t('janto_iframe_module.select_ticket_types')}
        </span>
      </ModuleHeader>
      <ModuleBody status={status} className={cn('border', 'border-top-0', 'rounded-bottom')}>
        <div style={{overflow: 'hidden', height: iframe_height}}>
          <div key={iframe_key} id={iframe_container_id}></div>
          <div id="cart-summary"></div>
        </div>
      </ModuleBody>
      <ModuleFooter {...props}/>
    </ModulePanel>
  )
}

export default ExperticketIframeModule
